module.exports = __webpack_public_path__ + "static/media/pants.ba84776a.png";